export default "__VITE_ASSET__e38131b8__"